import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    redirect: '/index',
    meta: { title: '首页'}
  },
  {
    path: '/index',
    name: 'Index',
    component: ()=>  import('@/views/Index/index'),
    meta: { title: '首页'}
  },
  {
    path: '/trip/index',
    name: 'TripList',
    component: ()=>  import('@/views/Person/tripList'),
    meta: { title: '首页'}
  },
  {
    path: '/trip/add',
    name: 'Trip',
    component: ()=>  import('@/views/Person/trip'),
    meta: { title: '创建行程单'}
  },
  {
    path: '/login',
    name: 'Login',
    component: ()=>  import('@/views/Login/index'),
    meta: { title: '登录'}
  },
  {
    path: '/miniLogin',
    name: 'MiniLogin',
    component: ()=>  import('@/views/MiniLogin/index'),
    meta: { title: '登录'}
  },
  {
    path: '/register',
    name: 'Register',
    component: ()=>  import('@/views/Register/index'),
    meta: { title: '注册'}
  },
  {
    path: '/resetPassword',
    name: 'ResetPassword',
    component: ()=>  import('@/views/ResetPassword/index'),
    meta: { title: '找回密码'}
  },
  {
    path: '/visaProcessing',
    name: 'VisaProcessing',
    component: ()=>  import('@/views/VisaProcessing/index'),
    meta: { title: '签证办理'}
  },
  {
    path: '/visaProcessList',
    name: 'VisaProcessList',
    component: ()=>  import('@/views/VisaProcessing/visaList'),
    meta: { title: '签证办理产品列表'}
  },
  {
    path: '/visaProcessDetail',
    name: 'VisaProcessDetail',
    component: ()=>  import('@/views/VisaProcessing/visaDetail'),
    meta: { title: '签证办理产品详情'}
  },
  {
    path: '/visaKnowledge',
    name: 'VisaKnowledge',
    component: ()=>  import('@/views/VisaKnowledge/index'),
    meta: { title: '签证知识'}
  },
  {
    path: '/visaKnowledgeDetail',
    name: 'VisaKnowledgeDetail',
    component: ()=>  import('@/views/VisaKnowledge/detail'),
    meta: { title: '签证知识详情'}
  },
  {
    path: '/person',
    name: 'Person',
    component: ()=>  import('@/views/Person/index'),
    meta: { title: '个人中心'}
  },
  {
    path: '/addressManage',
    name: 'AddressManage',
    component: ()=>  import('@/views/AddressManage'),
    meta: { title: '地址管理'}
  },
  {
    path: '/countryManage',
    name: 'CountryManage',
    component: ()=>  import('@/views/CountryManage'),
    meta: { title: '国家管理'}
  },
  {
    path: '/hotelManage',
    name: 'HotelManage',
    component: ()=>  import('@/views/HotelManage'),
    meta: { title: '酒店管理'}
  },
  {
    path: '/usersManage',
    name: 'UsersManage',
    component: ()=>  import('@/views/UsersManage'),
    meta: { title: '员工管理'}
  },
  {
    path: '/order-detail/:id',
    name: 'OrderDetail',
    component: ()=>  import('@/views/Person/OrderDetail'),
    meta: { title: '订单详情'}
  },
  {
    path: '/upload-material',
    name: 'UploadMaterial',
    component: ()=>  import('@/views/Person/UploadMaterial'),
    meta: { title: '俄罗斯签证'}
  },
  {
    path: '/sabic',
    name: 'Sabic',
    component: ()=>  import('@/views/Person/Sabic'),
    meta: { title: '沙特签证'}
  },
  {
    path: '/srilanka',
    name: 'Srilanka',
    component: ()=>  import('@/views/Person/UploadSrilanka'),
    meta: { title: '斯里兰卡签证'}
  },
  {
    path: '/mongolia',
    name: 'Mongolia',
    component: ()=>  import('@/views/Person/UploadMongolia'),
    meta: { title: '蒙古国签证'}
  },
  {
    path: '/schengen',
    name: 'Schengen',
    component: ()=>  import('@/views/Person/UploadSchengen'),
    meta: { title: '申根国家签证'}
  },
  {
    path: '/schengen',
    name: 'Schengen',
    component: ()=>  import('@/views/Person/UploadSchengen'),
    meta: { title: '申根国家签证'}
  },
  {
    path: '/schengen/info',
    name: 'SchengenInfo',
    component: ()=>  import('@/views/Person/UploadInfo'),
    meta: { title: '客人信息收集表'}
  },
  {
    path: '/schengen/createinfo',
    name: 'Createinformation',
    component: ()=>  import('@/views/Person/CreateSchengenInformation'),
    meta: { title: '申根签证创建资料'}
  },
  {
    path: '/schengen/spain',
    name: 'SchengenSpain',
    component: ()=>  import('@/views/Person/UploadSpainSchengen'),
    meta: { title: '申根西班牙签证'}
  },
  {
    path: '/schengen/italy',
    name: 'SchengenItaly',
    component: ()=>  import('@/views/Person/UploadItalySchengen'),
    meta: { title: '申根意大利签证'}
  },
  {
    path: '/schengen/holland',
    name: 'SchengenHolland',
    component: ()=>  import('@/views/Person/UploadHollandSchengen'),
    meta: { title: '申根荷兰签证'}
  },
  {
    path: '/schengen/germany',
    name: 'SchengenGermany',
    component: ()=>  import('@/views/Person/UploadGermanySchengen'),
    meta: { title: '申根德国签证'}
  },
  {
    path: '/payment',
    name: 'Payment',
    component: ()=>  import('@/views/Payment'),
    meta: { title: '订单支付'}
  },
  {
    path: '/aboutUs',
    name: 'AboutUs',
    component: ()=>  import('@/views/AboutUs/index'),
    meta: { title: '关于我们'}
  },
  {
    path: '/qa',
    name: 'Qa',
    component: ()=>  import('@/views/Qa/index'),
    meta: { title: 'QA'}
  },
  {
    path: '/serviceAgreement',
    name: 'ServiceAgreement',
    component: ()=>  import('@/views/ServiceAgreement/index'),
    meta: { title: '服务协议'}
  },
  {
    path: '/privacyPolicy',
    name: 'PrivacyPolicy',
    component: ()=>  import('@/views/PrivacyPolicy/index'),
    meta: { title: '个人信息保护政策'}
  },
  {
    path: '/messageList',
    name: 'MessageList',
    component: ()=>  import('@/views/MessageList/index'),
    meta: { title: '消息中心'}
  },
]

const router = new VueRouter({
  routes,
  // mode:'history'
})

export default router
